import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ListLayout, ListLayoutSingleComponent } from 'gung-list';
import { Observable, tap } from 'rxjs';
import { DeliveryLocationListCardComponent } from '../../components/delivery-location-list-card/delivery-location-list-card.component';
import { Customer } from '../../models';
import { CustomerListConfigService } from '../customer-list-config/customer-list-config.service';
import { MetadataService } from '../metadata/metadata.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryLocationListConfigService extends CustomerListConfigService {
  public metadataService = inject(MetadataService);
  public router = inject(Router);

  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => DeliveryLocationListCardComponent,
        getListLayoutComponent: () => ListLayoutSingleComponent,
        getName: () => 'Customer list'
      }
    ];
  }

  getItems(): Observable<Customer[]> {
    return this.customerService.getCustomers().pipe(
      tap(customers => {
        if (!customers || customers.length < 2) {
          this.router.navigate(['/categories']);
        }
      })
    );
  }
}
